require('./FiocProfession.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ components
const FiocProfessionSearchByCategory = require('./FiocProfessionSearchByCategory/FiocProfessionSearchByCategory');
// @ actions
const contractsActions = require('actions/contracts');
// @utilities
const { findElementbyId } = require('../../utilities/contractStateHelper');

class FiocProfession extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            selectedCategory: ''
        }
        this.handleSelectedCategory = this.handleSelectedCategory.bind(this);
    }

    componentDidMount() {
        const {
            getProfessionCnoSubcategoryPublic,
            getProfessionCnoPublicItem,
            prefix
        } = this.props;
        this.professionFieldEmpty('professionCnoSubcategoriesPublic') && getProfessionCnoSubcategoryPublic();
        this.professionFieldEmpty(`${prefix}professionCnoPublicCategoryItems`) && getProfessionCnoPublicItem(prefix);

    }

    buildSearchByCategory() {
        const {
            component,
            contractWizard,
            handleOnChange,
            prefix,
            value
        } = this.props;
        const cardDetails = contractWizard.get('card_details');
        const categoryOptions = contractWizard.get('professionCnoSubcategoriesPublic');
        let { selectedCategory } = this.state;
        let categoryItemsField = 'professionCnoPublicCategoryItems';
        const categoryItems = contractWizard.get(prefix ? `${prefix}${categoryItemsField}` : categoryItemsField);
        selectedCategory = findElementbyId(cardDetails, prefix + 'fioc_profession_category');

        let categoryId = '';
        let subcategoryId = '';
        if (selectedCategory) {
            categoryId = selectedCategory;
            subcategoryId = value;
        }
        const searchByCategoryConfiguration = {
            component,
            error: {
                categoryError: findElementbyId(cardDetails, prefix + 'fioc_profession_category', null, false),
                professionError: findElementbyId(cardDetails, prefix + 'fioc_profession', null, false)
            },
            handleOnChange,
            categoryId,
            options: categoryOptions.toJS(),
            subcategoryId
        };
        const optionClass = classNames('fioc-profession__option-body', {
            'fioc-profession__option-body--disabled': !selectedCategory
        });
        return (
            <div className="fioc-profession__category-search">
                <div className={optionClass}>
                    <FiocProfessionSearchByCategory
                        category={selectedCategory}
                        categoryItems={categoryItems}
                        component={component}
                        configuration={searchByCategoryConfiguration}
                        onChangeCategory={this.handleSelectedCategory}
                    />
                </div>
            </div>
        );
    }

    handleSelectedCategory(event) {
        const { value: categoryId } = event;
        const {
            contractWizard,
            prefix = '',
            updateCardDetails,
        } = this.props;
        const cardDetails = contractWizard.get('card_details');
        const newState = cardDetails.update(cardDetails.findIndex(
            stateObject => stateObject.get('id') === prefix + 'fioc_profession_category'),
            obj => obj.withMutations(map => { map.set('value', categoryId).set('isErrorVisible', false) })
        );
        this.setState({ selectedCategory: categoryId });
        updateCardDetails(newState);
    }


    professionFieldEmpty(field) {
        const { contractWizard } = this.props;
        return contractWizard.get(field).size === 0;
    }

    resetValue(state, componentId, setToFalsy = false) {
        const value = setToFalsy ? false : '';
        if (Array.isArray(componentId)) {
            componentId.forEach(id => {
                state.find(component => component.get('id') === id).set('value', value);
            });
        } else {
            state.find(component => component.get('id') === componentId).set('value', value);
        }
    }

    render() {
        const searchByCategory = this.buildSearchByCategory();
        return (
            <div className="fioc-profession">
                {searchByCategory}
            </div>
        )
    }
}

FiocProfession.propTypes = {
    autocompleteConfiguration: PropTypes.object,
    component: PropTypes.object,
    contractWizard: PropTypes.object.isRequired,
    error: PropTypes.object,
    getProfessionCnae: PropTypes.func.isRequired,
    getProfessionCnaeCategory: PropTypes.func.isRequired,
    getProfessionCno: PropTypes.func.isRequired,
    getProfessionCnoPrivate: PropTypes.func.isRequired,
    getProfessionCnoPrivateItem: PropTypes.func.isRequired,
    getProfessionCnoPublicItem: PropTypes.func.isRequired,
    getProfessionCnoSubcategoryPrivate: PropTypes.func.isRequired,
    getProfessionCnoSubcategoryPublic: PropTypes.func.isRequired,
    handleOnChange: PropTypes.func,
    prefix: PropTypes.string.isRequired,
    professionError: PropTypes.object,
    value: PropTypes.any,
    updateCardDetails: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    contractWizard: state.contracts,
});

const mapDispatchToProps = ({
    getProfessionCnae: contractsActions.getProfessionCnae,
    getProfessionCnaeCategory: contractsActions.getProfessionCnaeCategory,
    getProfessionCno: contractsActions.getProfessionCno,
    getProfessionCnoPrivate: contractsActions.getprofessionCnoPrivate,
    getProfessionCnoPrivateItem: contractsActions.getProfessionCnoPrivateItem,
    getProfessionCnoPublicItem: contractsActions.getProfessionCnoPublicItem,
    getProfessionCnoSubcategoryPrivate: contractsActions.getProfessionCnoSubcategoryPrivate,
    getProfessionCnoSubcategoryPublic: contractsActions.getProfessionCnoSubcategoryPublic
});

module.exports = connect(mapStateToProps, mapDispatchToProps)(FiocProfession);